import { createFileRoute } from "@tanstack/react-router"
import { TmpPage } from "@/app"

export const Route = createFileRoute("/(user)/tmp")({
  component: RouteComponent,
})

function RouteComponent() {
  return <TmpPage />
}
